<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="layout--main"
    :class="[
      layoutTypeClass,
      navbarClasses,
      footerClasses,
      {
        'app-page': isAppPage,
        'tinny-screen': tinnyScreen,
        'tinny-s-screen': tinnysScreen,
        'small-screen': smallScreen,
        'small-s-screen': smallsScreen,
        'medium-screen': mediumScreen,
        'large-screen': largeScreen,
        'big-screen': bigScreen,
        'huge-screen': hugeScreen,
      },
    ]"
  >
    <!-- <vx-tour :steps="tourSteps"/> -->

    <header-mobile v-if="!isDesktop"></header-mobile>

    <!-- :reportDetail="draggableComponentData.reportData" -->
    <draggable-multimedia
      v-if="draggableComponentData.displayDraggableMultimedia"
      :currentMediaData="draggableComponentData.currentMediaData"
      :isTextSpeech="draggableComponentData.isTextSpeech"
      :isDesktop="isDesktop"
      @close="closeMultimediaDraggable"
    ></draggable-multimedia>

    <div class="corner-ribbon top-left sticky red" v-if="!isProduction">
      {{ bannerValue }}
    </div>

    <the-customizer
      v-if="!disableCustomizer"
      :footerType="footerType"
      :hideScrollToTop="hideScrollToTop"
      :navbarType="navbarType"
      :navbarColor="navbarColor"
      :routerTransition="routerTransition"
      @toggleHideScrollToTop="toggleHideScrollToTop"
      @updateFooter="updateFooter"
      @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor"
      @updateRouterTransition="updateRouterTransition"
    />

    <subscriber-tools v-if="showSubscribeTools" :isDesktop="isDesktop" />
    <author-detail :isDesktop="isDesktop" />

    <v-nav-menu
      v-if="showNavMenu"
      :navMenuItems="navMenuItems"
      :logo="navMenuLogo"
      :logoReduced="logoReducedByTheme"
      :mainMenuReduceNotHoverExpand="mainMenuReduceNotHoverExpand"
      title
      parent=".layout--main"
      @open-register="openRegister"
      @login="openLogin"
      @open-plans="openPlans"
      @update-current-commodity="updateCurrentCommodityToAll"
    />

    <!-- <div id="content-area content-area-full" :class="[{'show-overlay': bodyOverlay}]"> -->
    <div
      id="content-area"
      :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]"
    >
      <div id="content-overlay" />

      <!-- Navbar -->
      <!-- <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :logo="navMenuLogo"
          :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"/>

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
          :navMenuItems="navMenuItems"/>
      </template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"/>
      </template>-->
      <!-- /Navbar -->

      <div class="content-wrapper content-wrapper-cma">
        <div class="router-view router-cma">
          <div class="router-content router-content-cma">
            <transition :name="routerTransition">
              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6"
              >
                <div
                  class="content-area__heading"
                  :class="{
                    'pr-4 border-0 md:border-r border-solid border-grey-light':
                      $route.meta.breadcrumb,
                  }"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                />

                <!-- DROPDOWN -->
                <vs-dropdown
                  vs-trigger-click
                  class="ml-auto md:block hidden cursor-pointer"
                >
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/pages/profile').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="UserIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/apps/todo').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="CheckSquareIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div
                        @click="$router.push('/apps/email').catch(() => {})"
                        class="flex items-center"
                      >
                        <feather-icon
                          icon="MailIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </transition>

            <div class="content-area__content content-area-cma">
              <back-to-top
                bottom="5%"
                visibleoffset="500"
                v-if="!hideScrollToTop"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <!-- <the-footer/> -->
    </div>

    <!-- v-if="!isAuthenticated" -->
    <vs-popup
      title
      :active.sync="displayPopupContentExclusive"
      class="popup-content-exclusive"
      :style="insetStyle"
    >
      <!-- <custom-content
        v-if="!isAuthenticated"
        :isDesktop="isDesktop"
        :displayCloseBtn="false"
        @open-register="openRegister"
      /> -->
      <private-content
        @close="displayPopupContentExclusive = false"
        @open-register="openRegister"
      ></private-content>
    </vs-popup>
    <vs-popup
      :title="$t('PACKAGES').Title"
      :active.sync="displayPopupPackages"
      class="popup-plans custom-content-scroll"
      :style="insetStyle"
      v-if="!isAuthenticated"
    >
      <packages v-if="displayPopupPackages" />
    </vs-popup>

    <authentications-page
      ref="authentication-page"
      v-if="!isAuthenticated"
      :isDesktop="isDesktop"
    ></authentications-page>

    <!-- <vs-popup title="" :active.sync="displayForgotPasswordPopup" class="forgot-password-popup" v-if="isDesktop">
      <forgot-password @close="displayForgotPasswordPopup=false" @back="openLogin"></forgot-password>
    </vs-popup>
    <vs-popup title="" :active.sync="displayLoginPopup" class="login-popup" v-if="isDesktop">
      <login @close="openLogin" @open-register="openRegister" @open-forgot-password="openForgotPassword" @open-lost-access="openLostAccess" @open-privacy-policy="openPrivacyPolicy"></login>
    </vs-popup>
    <vs-popup title="" :active.sync="displayRegisterPopup" id="register-popup" class="register-popup"  v-if="isDesktop">
      <register @close="displayRegisterPopup=false" @open-login="openLogin" @open-privacy-policy="openPrivacyPolicy"></register>
    </vs-popup>
    <vs-popup title="" :active.sync="displayLostAccessPopup" id="lost-access-popup" class="lost-access-popup" v-if="isDesktop">
      <lost-access @close="displayLostAccessPopup=false" @back="openLogin"></lost-access>
    </vs-popup>
    <vs-popup :title="$t('HELP_PRIVACY_POLICY').Title" :active.sync="displayPopupPrivacyPolicy" class="privacy-policy-modal">
      <privacy-policy></privacy-policy>
    </vs-popup> -->
  </div>
</template>

<script>
import BackToTop from "vue-backtotop";
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
import TheCustomizer from "@/layouts/components/customizer/TheCustomizer.vue";
import SubscriberTools from "@/layouts/components/customizer/SubscriberTools.vue";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";
import localStorageHelper from "../../helpers/local-storage-helper";
import CheckDeviceTypeHelper from "../../helpers/check-device-type-helper";
import AppConstants from "../../appConstants";
import HeaderMobile from "./HeaderMobile.vue";
import DraggableMultimedia from "../../views/pages/widgets/draggable-multimedia/DraggableMultimedia.vue";
import { EventBus } from "../../event-bus";
import {
  getCodeLang,
  getCodeLangFromBrowser,
  getMomentLocale,
} from "@/helpers/locale-helper";
// import TourSteps from '../../tourSteps'

import VxTour from "../../components/VxTour.vue";
import messageDialogHelper from "../../helpers/message-dialog-helper";
import layoutService from "../../providers/layoutService";
import mediaService from "../../providers/mediaService";

import Login from "../../views/pages/Login.vue";
import Register from "../../views/pages/Register.vue";
import LostAccess from "../../views/pages/LostAccess.vue";
import ForgotPassword from "../../views/pages/ForgotPassword.vue";
import PrivacyPolicy from "../../views/pages/help/PrivacyPolicy.vue";
import newsHomeService from "../../providers/newsHomeService";
import userService from "../../providers/userService";
import dropdownService from "../../providers/dropdownService";
import AuthorDetail from "../components/customizer/AuthorDetail.vue";
import CustomContent from "../../views/pages/CustomContent.vue";
import AuthenticationsPage from "../../views/pages/AuthenticationsPage.vue";
import { updateVeeValidateLocale } from "../../helpers/locale-helper";
import authService from "../../providers/authService";
import ChangeZoom from "../../../src/plugins/ChangeZoom";
import PrivateContent from "../../views/pages/private-content/PrivateContent.vue";
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";
import router from "@/router";
import Packages from "../../views/pages/Packages.vue";
import generalHelper from "../../helpers/general-helper";
import menuBuilderHelper from "../../helpers/menu-builder-helper";
import store from "@/store/store";

import {
  stopCountAndSendSpentTime,
  getTimeSpentOnSiteInSeconds,
  startCounting,
  clearCounting,
} from "../../../src/plugins/TimeSpend";
import reportService from "../../providers/reportService";
import { getInsetStyle } from "../../helpers/inset-style-helper";

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheCustomizer,
    SubscriberTools,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    HeaderMobile,
    DraggableMultimedia,
    VxTour,
    Login,
    Register,
    LostAccess,
    ForgotPassword,
    PrivacyPolicy,
    AuthorDetail,
    CustomContent,
    AuthenticationsPage,
    PrivateContent,
    Packages,
  },
  data() {
    return {
      disableCustomizer: themeConfig.disableCustomizer,
      showSubscribeTools: true,
      showAuthorDetail: true,
      showNavMenu: false,
      disableThemeTour: themeConfig.disableThemeTour,
      mainMenuReduceNotHoverExpand: themeConfig.mainMenuReduceNotHoverExpand,
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      navMenuItems: [],
      navMenuLogo: require("@/assets/images/logo/logo-black.svg"),
      navMenuLogoReduced: require("@/assets/images/pages/logo.svg"),
      navMenuLogoReducedDark: require("@/assets/images/logo/logo-vertical-white.svg"),
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
      // isDesktop: true,
      draggableComponentData: {
        displayDraggableMultimedia: false,
        reportData: null,
        currentMediaData: null,
        isTextSpeech: false,
      },
      tourSteps: [],
      displayPage: false,
      displayLoginPopup: false,
      displayRegisterPopup: false,
      displayForgotPasswordPopup: false,
      displayLostAccessPopup: false,
      displayPopupPrivacyPolicy: false,
      displayPopupContentExclusive: false,
      displayPopupPackages: false,
      calcDiffHeightMainContent: 0,
    };
  },
  watch: {
    "$store.state.displaySubscribeTools"(value) {
      this.showSubscribeTools = value;
    },
    "$store.state.displayAuthorDetail"(value) {
      this.showAuthorDetail = value;
    },
    "$store.state.displayNavMenu"(value) {
      this.showNavMenu = value;
    },
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
      this.disableThemeTour = true;
    },
    windowWidth(val) {
      if (val < 1200) this.disableThemeTour = true;
    },
    verticalNavMenuWidth() {
      this.disableThemeTour = true;
    },
    "$i18n.locale"(value) {
      this.loadMainMenu();
      // this.navMenuItems = MenuBuilderHelper.buildMenu(
      //   this.$store.state.AppActiveUser.rights
      // );
      // this.tourSteps = TourSteps.getSteps();

      this.$moment.locale(getMomentLocale(value));
      updateVeeValidateLocale(value);
    },
  },
  computed: {
    insetStyle() {
      return getInsetStyle();
    },
    isWindowDetached() {
      return !!this.$route.query.currentCommodity;
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    logoReducedByTheme() {
      if (this.isThemeDark) {
        return this.navMenuLogoReducedDark;
      }
      return this.navMenuLogoReduced;
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    tinnyScreen() {
      return generalHelper.tinnyScreen(this.windowWidth);
    },
    tinnysScreen() {
      return generalHelper.tinnysScreen(this.windowWidth);
    },
    smallScreen() {
      return generalHelper.smallScreen(this.windowWidth);
    },
    smallsScreen() {
      return generalHelper.smallsScreen(this.windowWidth);
    },
    mediumScreen() {
      return generalHelper.mediumScreen(this.windowWidth);
    },
    largeScreen() {
      return generalHelper.largeScreen(this.windowWidth);
    },
    bigScreen() {
      return generalHelper.bigScreen(this.windowWidth);
    },
    hugeScreen() {
      return generalHelper.hugeScreen(this.windowWidth);
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
      // return authService.isAuthenticated();
    },
    // navMenuItems() {
    //   return MenuBuilderHelper.buildMenu(this.$store.state.AppActiveUser.rights) || [];
    // },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default")
          return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced")
          return "content-area-lg";
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
    isAppPage() {
      return this.$route.path.includes("/apps/") ? true : false;
    },
    isThemeDark() {
      return this.$store.state.theme == AppConstants.THEME.DARK;
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isProduction() {
      return this.$store.state.isProduction;
    },
    bannerValue() {
      if (this.$config.api_url.indexOf("dev-plataforma") > 0) {
        return "DEV";
      } else if (this.$config.api_url.indexOf("ctdevwebbackend") > 0) {
        return "CT";
      } else {
        return "DEMO";
      }
    },
  },
  methods: {
    async loadDataWindowDetached() {
      console.log(
        "[isWindowDetached] loading current commodity and content data"
      );
      const currentCommodityQuery = this.$route.query.currentCommodity;
      const currentContentQuery = this.$route.query.currentContent;
      const quotesList = await this.loadQuotesContentList();

      const commodity = this.navMenuItems[0].items.find(
        (item) => Number(item.id) == Number(currentCommodityQuery)
      );
      if (commodity) {
        this.$store.dispatch("updateCurrentCommodity", commodity);
      }
      const quotesContent = quotesList.find(
        (item) => Number(item.id) == Number(currentContentQuery)
      );
      if (quotesContent) {
        this.$store.dispatch("updateCurrentContent", quotesContent);
      }
    },
    async loadQuotesContentList() {
      const params = new URLSearchParams();
      // params.append("commodity", this.currentCommodity.id);
      const resp = await reportService.getAllQuotesContentList(params);
      this.$store.dispatch("updateQuotesContentList", resp);
      // console.log('[loadQuotesContentList] ', resp);
      return resp;
    },
    stopCountSpentTime() {
      // send to api spend time on platform
      stopCountAndSendSpentTime();
    },
    checkUserProfile() {
      if (this.isAuthenticated && this.AppActiveUser) {
        if (this.AppActiveUser.profile == AppConstants.USER_PROFILE.FREE) {
          messageDialogHelper.displayDialogConfirmCancelWithText(
            "Perfil",
            "Identificamos que usa conta é gratuito, conheça nossos planos ou peça uma demonstração.",
            "Ver planos",
            "Pedir demonstração",
            (callback) => {
              if (callback == "accept") {
                this.$router.push(
                  AppConstants.NAVIGATION_PAGE_ACCOUNT_SIGNATURE
                );
              } else if (callback == "cancel") {
                this.$router.push(AppConstants.NAVIGATION_PAGE_ACCOUNT);
              }
            }
          );
        }
      }
    },
    loadFilterUsers() {
      if (this.isAuthenticated) {
        dropdownService
          .getUsers(new URLSearchParams())
          .then((res) => {
            this.$store.dispatch("updateFilterUsers", res);
          })
          .catch((err) => console.log(err));
      }
    },
    openPrivacyPolicy() {
      this.displayPopupPrivacyPolicy = true;
    },
    openLogin() {
      if (this.$refs["authentication-page"]) {
        this.$refs["authentication-page"].openLogin();
        return;
      }
      router.push({ path: checkDeviceTypeHelper.getUrlLogin() });
    },
    openRegister() {
      this.displayPopupContentExclusive = false;
      if (this.$refs["authentication-page"]) {
        this.$refs["authentication-page"].openRegister();
        return;
      }
      this.$router.push(AppConstants.NAVIGATION_PAGE_REGISTER);
    },
    openPlans() {
      this.displayPopupPackages = true;
    },
    openForgotPassword() {
      if (this.$refs["authentication-page"]) {
        this.$refs["authentication-page"].openForgotPassword();
        return;
      }
      this.$router.push(AppConstants.NAVIGATION_PAGE_FORGOT_PASSWORD);
    },
    openLostAccess() {
      if (this.$refs["authentication-page"]) {
        this.$refs["authentication-page"].openLostAccess();
        return;
      }
      this.$router.push(AppConstants.NAVIGATION_PAGE_LOST_ACCESS);
    },
    async loadMainMenu() {
      if (!this.isAuthenticated) {
        const resp = await newsHomeService.getAllSubjectCache(
          new URLSearchParams()
        );
        this.navMenuItems = menuBuilderHelper.buildCacheMenu(resp);
        this.$store.dispatch("updateSubjectMenu", this.navMenuItems);
        this.updateCurrentCommodity();
        return;
      } else {
        // if loggedin get menu in userInfo
        // const currentRights = await authService.getMainMenu(new URLSearchParams());
        // this.navMenuItems = MenuBuilderHelper.buildMenu(this.$store.state.AppActiveUser.rights);
        this.navMenuItems =
          menuBuilderHelper.buildMenu(this.$store.state.AppActiveUser.rights) ||
          [];
        this.$store.dispatch("updateSubjectMenu", this.navMenuItems);
        this.updateCurrentCommodity();
        return;
      }

      // get current menu selected to store
      // if (!this.$store.state.currentCommodity.id) {
      //   // get commodity in url
      //   if (this.$route.params.commodity) {
      //     const commodity = this.navMenuItems[0].items.find(item => Number(item.id) == Number(this.$route.params.commodity));
      //     this.$store.dispatch('updateCurrentCommodity', commodity);
      //   } else {
      //     // get default menu item (first item in menu)
      //     this.$store.dispatch('updateCurrentCommodity', this.navMenuItems[0].items[0]);
      //   }
      // }
    },
    updateCurrentCommodity() {
      // console.log('updateCurrentCommodity', this.$store.state.currentCommodity);
      // console.log('[updateCurrentCommodity]', this.$route.path);
      // console.log('[updateCurrentCommodity]', this.$route.name);
      if (
        this.$store.state.currentCommodity &&
        !this.$store.state.currentCommodity.id
      ) {
        if (this.$route.params.commodity) {
          const commodity = this.navMenuItems[0].items.find(
            (item) => Number(item.id) == Number(this.$route.params.commodity)
          );
          if (commodity) {
            this.$store.dispatch("updateCurrentCommodity", commodity);
            return;
          }
        }
        this.$store.dispatch(
          "updateCurrentCommodity",
          this.navMenuItems[0].items[0]
        );
        if (this.$route.name != "quotes") {
          this.$router.push({
            path: `${menuBuilderHelper.getInformativePageFirstItemMenu()}`,
          });
        }
      }
    },
    updateCurrentCommodityToAll() {
      this.$router.push({
        path: `${menuBuilderHelper.getInformativePageFirstItemMenu()}`,
      });
      this.$store.dispatch(
        "updateCurrentCommodity",
        this.navMenuItems[0].items[0]
      );
    },
    setUpdatedZoom(zoom) {
      if (zoom === AppConstants.ZOOM.ULTRACOMPACT) {
        ChangeZoom.setUltraCompact();
      }

      if (zoom === AppConstants.ZOOM.COMPACT) {
        ChangeZoom.setCompact();
      }

      if (zoom === AppConstants.ZOOM.BIG) {
        ChangeZoom.setBig();
      }
    },
    async loadUserLayoutPrefs() {
      if (this.isAuthenticated) {
        let viewImportantTickers = localStorageHelper.getViewImportantTickers();
        if (
          viewImportantTickers === null ||
          viewImportantTickers === undefined ||
          viewImportantTickers === ""
        ) {
          viewImportantTickers = true;
        }
        this.$store.dispatch("viewImportantTickers", viewImportantTickers);

        let viewHighlightsTickers =
          localStorageHelper.getViewHighlightsTickers();
        if (
          viewHighlightsTickers === null ||
          viewHighlightsTickers === undefined ||
          viewHighlightsTickers === ""
        ) {
          viewHighlightsTickers = true;
        }
        this.$store.dispatch("viewHighlightsTickers", viewHighlightsTickers);

        if (localStorageHelper.getBiometry() === "1") {
          store.dispatch("updateBiometry", "1");
        }

        const res = await layoutService.loadLayout(new URLSearchParams());
        if (res) {
          this.setUpdatedZoom(res.zoom);
          localStorageHelper.saveData(
            AppConstants.LOCAL_STORAGE_THEME,
            res.theme
          );
          this.$store.dispatch("updateTheme", res.theme);
          // console.log('[res.viewstyle]', res.viewstyle);
          if (res.viewstyle == 0) {
            res.viewstyle = AppConstants.REPORT_VIEW_STYLE.LISTVIEW;
          }
          if (
            (res.viewstyle == AppConstants.REPORT_VIEW_STYLE.CARDVIEW ||
              res.viewstyle == AppConstants.REPORT_VIEW_STYLE.MOSAIC) &&
            !this.isDesktop
          ) {
            res.viewstyle = AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED;
          }

          localStorageHelper.saveData(
            AppConstants.LOCAL_STORAGE_REPORT_VIEW_STYLE,
            res.viewstyle
          );
          this.$store.dispatch("reportListStyle", res.viewstyle);

          if (res.language) {
            localStorageHelper.saveData(
              AppConstants.LOCAL_STORAGE_LOCALE,
              res.language
            );
            this.$i18n.locale = getCodeLang(res.language);
          }

          this.$store.dispatch("setDisplayTicker", res.canDisplayTicker);
          this.$store.dispatch("setTickerViewAtTheTop", res.tickerViewAtTheTop);

          localStorageHelper.updateUserSkipTour(res.skipTour);

          // update currentUser
          const currentUser = localStorageHelper.getCurrentUser();
          currentUser.viewstyle = res.viewstyle;
          currentUser.theme = res.theme;
          currentUser.canDisplayTicker = res.canDisplayTicker;
          currentUser.tickerViewAtTheTop = res.tickerViewAtTheTop;
          currentUser.skipTour = res.skipTour;
          currentUser.zoom = res.zoom;
          currentUser.zoomDetail = res.zoomDetail;
          currentUser.formatAlignDetail = res.formatAlignDetail;
          currentUser.rateTextSpeech = res.rateTextSpeech || 1.0;
          localStorageHelper.setCurrentUser(currentUser);
          // currentUser.metadata = res.metadata;
          // currentUser.layout = res.layout;

          if (res.saved_news) {
            this.$store.dispatch(
              "setScheduleData",
              res.saved_news.map((item) => {
                return { _id: item };
              })
            );
          }
        }
      } else {
        let theme = localStorageHelper.getTheme();
        if (!theme) {
          theme = AppConstants.THEME.LIGHT;
        }
        localStorageHelper.updateTheme(theme);

        let formatAlign = localStorageHelper.getFormatAlignDetail();
        if (!formatAlign) {
          formatAlign = AppConstants.DETAIL_FORMAT_ALIGN.CENTER;
        }
        localStorageHelper.updateFormatAlignDetail(formatAlign);
        let viewStyle = localStorageHelper.getReportViewStyle();
        if (!viewStyle) {
          viewStyle = AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED;
        }
        // else if ((viewStyle == AppConstants.REPORT_VIEW_STYLE.CARDVIEW || viewStyle == AppConstants.REPORT_VIEW_STYLE.MOSAIC) && !this.isDesktop) {
        //   viewStyle = AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED;
        // }
        localStorageHelper.updateReportViewStyle(viewStyle);
        // localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_REPORT_VIEW_STYLE, viewStyle);
        // this.$store.dispatch("reportListStyle", viewStyle);
      }
      // Gets user prefs from 'currentUser' key
      // const userLayoutPrefs = localStorageHelper.getUserLayoutPrefs();
    },
    closeMultimediaDraggable() {
      this.draggableComponentData.displayDraggableMultimedia = false;
      this.$store.dispatch("removePlaylistItemSelected", null);
      this.$store.dispatch("updateCurrentMedia", null);
      // this.draggableComponentData.reportData = null;
      // this.draggableComponentData.currentMediaData = null;
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val == "static") this.updateNavbarColor("#fff");
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1200) ||
        (layoutType === "vertical" && this.windowWidth < 1200)
      ) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    playMedia(data) {
      data.reportDetail.isTextSpeech = data.isTextSpeech;
      this.$store.dispatch("addPlaylistItemSelected", data.reportDetail);
      this.$store.dispatch("updateCurrentMedia", data.reportDetail);
      this.draggableComponentData.displayDraggableMultimedia = true;
      this.draggableComponentData.reportData = data.reportDetail;
      this.draggableComponentData.currentMediaData = data.currentMediaData;
      this.draggableComponentData.isTextSpeech = data.isTextSpeech;
    },
    getLatestMedia() {
      if (this.isAuthenticated) {
        const params = new URLSearchParams();
        params.append("page", 1);
        params.append("limit", 10);
        mediaService
          .getLatestMedia(params)
          .then((res) => {
            this.$store.dispatch("updateLatestMedia", res.data);
          })
          .catch((err) => console.log(err));
      }
    },
    getContentPrivate() {
      // if (this.isAuthenticated) {
      //   userService.getContentPrivate(new URLSearchParams())
      //     .then((res) => {
      //       this.$store.dispatch('updateContentPrivate', res);
      //     })
      //   .catch((err) => console.log(err))
      // }
      // else {
      //   Promise.all([
      //     newsHomeService.getContentPrivatePublicDetail(new URLSearchParams()),
      //     newsHomeService.getContentPrivateQuotesPublic(new URLSearchParams())
      //   ]).then((res) => {
      //     this.$store.dispatch('updateContentPrivate', res[0]);
      //     this.$store.dispatch('updateQuotesPublic', res[1]);
      //   })
      //   .catch((err) => console.log(err));
      // }
    },
    logoutAcceptorOnReloadPage() {
      // localStorageHelper.setLogoutOnReloadPage(false);
      authService.logoutAcceptor();
    },
    async beforeUnloadFunc(event) {
      console.log("[beforeunload] init function");
      // if (!localStorageHelper.getEventOnLogin() && localStorageHelper.getLogoutOnReloadPage()) {
      if (!localStorageHelper.getEventOnLogin()) {
        console.log("[beforeunload] init logout acceptor");
        await authService.logoutAcceptor();
        // event.returnValue = "Deseja sair desta página? Você será desconectado ao continuar.";
      }
      // event.returnValue = "";
      console.log("[beforeunload] exit");
    },
    unloadFunc(event) {
      this.logoutAcceptorOnReloadPage();
      // if (!localStorageHelper.getEventOnLogin() && localStorageHelper.getLogoutOnReloadPage()) {
      //   authService.logout();
      // }
    },
    preventLogoutEvent(event) {
      // Verificar se a tecla pressionada é o F5 (código 116)
      if (event.keyCode === 116) {
        this.logoutAcceptorOnReloadPage();
      }

      // Verificar se as teclas pressionadas são Ctrl+R (Ctrl = 17, R = 82)
      if (event.ctrlKey && event.keyCode === 82) {
        this.logoutAcceptorOnReloadPage();
      }

      // Verificar se as teclas pressionadas são Ctrl+F5 (Ctrl = 17, F5 = 116)
      if (event.ctrlKey && event.keyCode === 116) {
        this.logoutAcceptorOnReloadPage();
      }
    },
    clearCurrentSession() {
      // console.log('process.env.NODE_ENV', process.env.NODE_ENV);
      // if (process.env.NODE_ENV !== 'production') return;
      if (
        this.isDesktop &&
        this.isAuthenticated &&
        !localStorageHelper.getS4Login() &&
        !localStorageHelper.getEventOnLogin()
      ) {
        // messageDialogHelper.displayDialogAccept('Sessão', 'Você está sendo desconectado da sua sessão atual. Favor faça seu login novamente.', () => {
        //   authService.logout();
        // });
        // window.addEventListener("keydown", this.preventLogoutEvent);
        // window.addEventListener("beforeunload", this.beforeUnloadFunc);
        // window.addEventListener("beforeunload", this.logoutAcceptorOnReloadPage);
        // window.addEventListener("unload", this.unloadFunc);
      }
    },
  },
  async created() {
    localStorageHelper.setLogoutOnReloadPage(true);
    // load locale from localstorage
    // console.log('[created main]')
    // console.log("MAIN LOCALE: ", getCodeLang(localStorageHelper.getLocale()));
    // const localeCode = localStorageHelper.getLocaleLocalStorage();
    // if (localeCode) {
    //   this.$i18n.locale = getCodeLang(localeCode);
    // } else {
    //   this.$i18n.locale = getCodeLangFromBrowser();
    // }

    const color =
      this.navbarColor === "#fff" && this.isThemeDark
        ? "#10163a"
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);
    this.$store.commit("UPDATE_USER_INFO", null);

    // this.isDesktop = CheckDeviceTypeHelper.isMobileOrDesktop() === AppConstants.DEVICE_TYPE_DESKTOP;
    // this.isDesktop = checkDeviceTypeHelper.isNativeApp();
    // this.$store.commit("UPDATE_DEVICE_IS_DESKTOP", this.isDesktop);
    await this.loadUserLayoutPrefs();
    await this.loadMainMenu();
    if (this.isWindowDetached) {
      await this.loadDataWindowDetached();
    }
    // this.clearCurrentSession();

    if (this.isAuthenticated) {
      clearCounting();
      startCounting();
      window.addEventListener("beforeunload", this.stopCountSpentTime);
    }

    this.showNavMenu = true;

    if (!this.isDesktop) {
      // adding meta in mobile to cancel zoom in browser
      var meta = document.createElement("meta");
      meta.name = "viewport";
      meta.content =
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
    // this.getLatestMedia();
    // this.getContentPrivate();
    this.loadFilterUsers();
    // this.checkUserProfile();
    localStorageHelper.updateEventOnLogin(false);
    // this.$store.dispatch("initCurrentFilter", localStorageHelper.getFilterReport());
    // if (authService.isAuthenticated()) {
    //   this.$store.dispatch("updateCurrentCommodity", localStorageHelper.getCurrentUser());
    // }

    // Draggable event
    EventBus.$on(AppConstants.BUS_EVENT_OPEN_DRAGGABLE_MULTIMEDIA, (data) => {
      this.playMedia(data);
    });
    EventBus.$on(AppConstants.BUS_EVENT_OPEN_REGISTER, () => {
      this.openRegister();
    });
    EventBus.$on(AppConstants.BUS_EVENT_OPEN_LOGIN, () => {
      this.openLogin();
    });
    EventBus.$on(AppConstants.BUS_EVENT_OPEN_PLANS, () => {
      this.openPlans();
    });
    EventBus.$on(AppConstants.BUS_EVENT_OPEN_EXCLUSIVE_CONTENT_POPUP, () => {
      this.displayPopupContentExclusive = !this.displayPopupContentExclusive;
    });

    EventBus.$on(AppConstants.BUS_EVENT_OPEN_TOUR, () => {
      // this.$tours['platformTour'].start();
      // if (!JSON.parse(localStorageHelper.getUserSkipTour())) {
      //   this.$tours['platformTour'].start();
      // }
    });

    EventBus.$on(AppConstants.BUS_EVENT_NAVIGATE_SUBJECT, (subjectCode) => {
      if (subjectCode) {
        const subject = this.navMenuItems[0].items.find(
          (item) => Number(item.id) == Number(subjectCode)
        );
        this.$store.dispatch("updateCurrentCommodity", subject);
        this.$router.push({
          path: `${AppConstants.NAVIGATION_PAGE_INFORMATIVE}/${subjectCode}`,
        });
      }
    });
  },
  mounted() {
    this.calcDiffHeightMainContent =
      document.querySelector(".content-wrapper-cma").getBoundingClientRect()
        .top + Number(this.$store.state.insetBottom);

    document.querySelector(
      ".content-wrapper-cma"
    ).style.minHeight = `calc(100vh - ${this.calcDiffHeightMainContent}px)`;

    document.querySelector(
      ".content-wrapper-cma"
    ).style.maxHeight = `calc(100vh - ${this.calcDiffHeightMainContent}px)`;
    // this.tourSteps = TourSteps.getSteps();
    // localStorageHelper.updateEventOnLogin(false);
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_DRAGGABLE_MULTIMEDIA);
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_TOUR);
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_REGISTER);
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_LOGIN);
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_PLANS);
    EventBus.$off(AppConstants.BUS_EVENT_OPEN_EXCLUSIVE_CONTENT_POPUP);
  },
};
</script>

<style lang="scss">
.content-wrapper-cma {
  display: flex;
  // min-height: calc(100vh) !important;
}

.router-cma {
  display: flex;
  float: left;
  width: 100%;
  /*background-color: green;*/
}

.router-content-cma {
  float: left;
  width: 100%;
}

.content-area-cma {
  height: 100%;
}
.main-flags {
  position: absolute;
  right: 4px;
  top: 4px;
  z-index: 999;
}
</style>
